import { dateFormats, swaDate } from "@swa-ui/date";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const DATE_OF_BIRTH_SCHEMA_FIELD_NAME = "dateOfBirth";

export const DATE_OF_BIRTH_MAX_LENGTH = 8;

export const getDateOfBirthFormFieldSchema = () =>
  yup
    .string()
    .required()
    .test(
      "invalidDate",
      (value) =>
        swaDate(value, dateFormats.default, true).isValid() &&
        swaDate(value).isBetween(swaDate().subtract(120, "year"), swaDate().add(1, "day"), "day")
    )
    .test("lapChildAge", i18n("DateOfBirthFormField__LAP_CHILD_INVALID_DATE"), function (value) {
      let isValidAge = true;
      const { departureDate, lapChild } = this.options.context || {};

      if (lapChild && value && departureDate) {
        const birthDate = swaDate(value);
        const flightDate = swaDate(departureDate);
        const ageInDays = flightDate.diff(birthDate, "days");
        const ageInYears = flightDate.diff(birthDate, "years", true);

        isValidAge = ageInDays >= 14 && ageInYears < 2;
      }

      return isValidAge;
    })
    .label(i18n("DateOfBirthFormField__LABEL"));
